import cn from 'classnames'
import { useStaticCrud } from 'legacy/lut/hooks/useStaticCrud'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { FormDropdown, FormInput } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations'
import { useAppDispatch } from 'cng-common/hooks/useAppDispatch'
import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { updateAssortmentItem } from 'partner360/features/assortment/assortmentSlice'
import {
  IAssortmentItem,
  TAssortmentDealStatus,
} from 'partner360/features/assortment/models/data/IAssortmentItem'

import { TRANSLATION_KEYS } from '../../../../translations'

import { OPTIONS } from './configs'

import styles from './DealStatus.module.scss'

interface IDealStatusProps {
  isEditMode: boolean
  item: IAssortmentItem
}

export const DealStatus: FC<IDealStatusProps> = ({ isEditMode, item }) => {
  const dispatch = useAppDispatch()

  const [wonButton, lostButton] = OPTIONS

  const status = useMemo(() => item.Status, [item.Status])
  const statusText = useMemo(() => item.StatusText, [item.StatusText])

  const handleChangeDealStatus = useCallback(
    (status: TAssortmentDealStatus) => {
      dispatch(
        updateAssortmentItem({
          ...item,
          Status: status,
        })
      )
    },
    [dispatch, item]
  )

  const handleChangeStatusText = useCallback(
    (statusText: string) => {
      dispatch(
        updateAssortmentItem({
          ...item,
          StatusText: statusText,
        })
      )
    },
    [dispatch, item]
  )

  if (isEditMode) {
    return (
      <div className={cn(styles.editRoot)}>
        <div>
          <div className={styles.readLabel}>
            <Translation text={TRANSLATION_KEYS.item.status} />
          </div>
          <div className={styles.row}>
            <Button
              onClick={() => handleChangeDealStatus(wonButton.value)}
              color={status === wonButton.value ? 'success' : 'grey'}
              className={styles.button}
            >
              {OPTIONS[0].title}
            </Button>
            <Button
              onClick={() => handleChangeDealStatus(lostButton.value)}
              color={status === lostButton.value ? 'danger' : 'grey'}
              className={styles.button}
            >
              {OPTIONS[1].title}
            </Button>
          </div>
        </div>
        <div className={styles.row}>
          <Input
            label={<Translation text={TRANSLATION_KEYS.item.statusText} />}
            value={item.StatusText}
            onChange={handleChangeStatusText}
          />
        </div>
      </div>
    )
  }

  return (
    <div
      className={cn(styles.viewRoot, {
        [styles.won]: status === 'won',
        [styles.lost]: status === 'lost',
      })}
    >
      <span>
        {status.toUpperCase()}
        <RenderWhen condition={!!statusText}>:</RenderWhen>
      </span>
      <RenderWhen condition={!!statusText}>
        <span>{statusText}</span>
      </RenderWhen>
    </div>
  )
}
